export const PREFS_KEY = 'user_prefs';

export const defaultPrefs = {
  theme: 'system',
  language: 'pt-BR',
  notificationsEnabled: false,
  notificationsBeep: true,
  notificationsSound: '',
};

export const themeOptions = [
  { value: 'system', label: 'System' },
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
];

export const languageOptions = [
  { value: 'pt-BR', label: 'Português (Brasil)' },
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
];
